import BordOneToneIcon from '../../../NudosComponents/BordOneToneIcon/BordOneToneIcon';
import './LargeQrButton.scss';

const LargeQrButton = ({
  getQrCodeCallback,
  disabled,
  isModeDark
}: {
  getQrCodeCallback: () => void;
  disabled: boolean;
  isModeDark?: boolean;
}) => {
  return (
    <div
      className={`largeQrButton ${disabled ? 'disabled' : ''} ${isModeDark ? 'isModeDark' : ''}`}
      onClick={disabled ? undefined : getQrCodeCallback}
    >
      <div className="qrDownloadButton">
        {isModeDark && <BordOneToneIcon variant="qr" customWidth="12px" stroke="#FFFFFF" />}
        Descargar QR
        {!isModeDark && <BordOneToneIcon variant="download" customWidth="10px" stroke="#070F21" />}
      </div>
    </div>
  );
};

export default LargeQrButton;
